import React from "react";
import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";

export const DrawerComponent = ({
  title,
  content,
  drawerVisible,
  onClose,
  maskClosable,
  ...rest
}) => (
  <Drawer
    title={title}
    placement="right"
    onClose={onClose}
    visible={drawerVisible}
    // White close icon so it is visible on the blue drawer header.
    closeIcon={<CloseOutlined style={{ fontSize: 22, color: "#fff" }} />}
    size="large"
    destroyOnClose
    // Clicking the mask/outside closes the drawer by default; a drawer that must
    // guard against accidental dismissal can pass maskClosable={false}.
    maskClosable={maskClosable !== undefined ? maskClosable : true}
    {...rest}
  >
    {content}
  </Drawer>
);
